import React, { useState, useEffect } from 'react';
import './Contacto.css';
import { db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

function Contacto({ id }) {
  const [contactInfo, setContactInfo] = useState({
    schedule: 'Lunes a Domingo: 12:00 PM - 10:00 PM',
    address: '¡Contamos con 5 sedes en Cartagena, Ven y conocelas!',
    city: 'Colombia',
    phone: '+57 3205570467',
    email: 'info@yoamobazurto.co',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d62785.602789034354!2d-75.53675646791987!3d10.41361823182859!3m2!1i1024!2i768!4f13.1!2m1!1syo%20amo%20bazurto!5e0!3m2!1sen!2sco!4v1753145966044!5m2!1sen!2sco',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const docRef = doc(db, 'siteSettings', 'contactInfo');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContactInfo(docSnap.data());
        } else {
        }
      } catch (error) {
        console.error("Error fetching contact info: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();
  }, []);

  if (loading) {
    return <section id={id} className="contacto-section">Cargando...</section>;
  }

  return (
    <section id={id} className="contacto-section">
      <div className="contacto-content">
        <div className="contacto-columns">
          <div className="contacto-column left-column">
            <div className="map-container">
              <iframe
                src={contactInfo.mapUrl}
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación de Yo Amo Bazurto"
              ></iframe>
            </div>
          </div>

          <div className="contacto-column right-column">
            <div className="right-column-content">
              <h3><i className="fas fa-clock"></i> Horario</h3>
              <p>{contactInfo.schedule}</p>

              <h3><i className="fas fa-map-marker-alt"></i> Nuestra Ubicación</h3>
              <p>{contactInfo.address}</p>
              <p>{contactInfo.city}</p>

              <h3><i className="fas fa-phone"></i> Teléfono</h3>
              <p>{contactInfo.phone}</p>

              <h3><i className="fas fa-envelope"></i> Email</h3>
              <p>{contactInfo.email}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contacto;
